import { createReducer } from '@ngrx/store';
import { trackerState } from '../tracker.state';
import { trackerCoreHandlers } from './tracker-core.reducer.handler';
import { trackerDetailHandlers } from './tracker-detail.reducer.handler';
import { trackerOverviewHandlers } from './tracker-overview.reducer.handler';
import { trackerSettingsHandlers } from './tracker-settings.reducer.handler';

/**
 * Combined tracker reducer that handles all tracker-related state updates.
 *
 * This reducer combines organized action handlers from:
 * - tracker-core.reducer.ts (Core functionality handlers)
 * - tracker-overview.reducer.ts (Overview page functionality handlers)
 * - tracker-detail.reducer.ts (Detail view functionality handlers)
 * - tracker-settings.reducer.ts (Settings and configuration handlers).
 *
 */
export const trackerReducer = createReducer(
  trackerState,
  // Spread all handler arrays to combine them into a single reducer
  ...trackerCoreHandlers,
  ...trackerOverviewHandlers,
  ...trackerDetailHandlers,
  ...trackerSettingsHandlers
);
